function openingAnimation() {
  
}

function hideOpening() {
  gsap.set('.js-loading', { autoAlpha: 0 })
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.js-loading').length) {
    
    if (sessionStorage.getItem('visited')) {
      hideOpening();
    } else {
      openingAnimation();
      
      sessionStorage.setItem('visited', 'true');
    }
  }
});
